export { setUser as setUser };
export { setKycRefData as setKycRefData };
export { setLoadingArray as setLoadingArray };
export { setCoins as setCoins };
export { setRefData as setRefData };
export { setCountries as setCountries };
function setUser(state, payload) {
  state.user = payload;
}
function setKycRefData(state, payload) {
  state.kycRefData = payload;
}
function setLoadingArray(state, payload) {
  state.isLoadingArray = payload;
}
function setCoins(state, payload) {
  state.coins = payload;
}
function setRefData(state, payload) {
  state.refData = payload;
}
function setCountries(state, payload) {
  state.countries = payload;
}

export default { setUser, setKycRefData, setLoadingArray, setCoins, setRefData, setCountries };
